(() => {
  if (window.easyUnifiedVariantsLoaded) return;
  window.easyUnifiedVariantsLoaded = true;
  let sequence = 0;
  let scheduled = false;
  const bindings = new WeakMap();
  const labels = ':scope > label,:scope > legend,:scope > .easy-flyer-label,:scope > .easy-booth-group-title';
  const compact = value => String(value || '').replace(/\s+/g, ' ').trim();
  function mirrorRadios(field) {
    const radios = Array.from(field.querySelectorAll('input[type="radio"]'));
    if (!radios.length || new Set(radios.map(radio => radio.name)).size !== 1) return;
    const label = field.querySelector(':scope > legend') || field.querySelector(labels);
    if (!label || label.querySelector('input')) return;
    let binding = bindings.get(field);
    if (!binding || !binding.select.isConnected) {
      const containers = Array.from(field.children).filter(child => child.querySelector('input[type="radio"]'));
      if (containers.some(child => child.querySelector('input:not([type="radio"]),textarea,select'))) return;
      const select = document.createElement('select');
      select.id = 'easy-unified-option-' + (++sequence);
      select.dataset.easyUnifiedMirror = '';
      if (!label.id) label.id = select.id + '-label';
      select.setAttribute('aria-labelledby', label.id);
      if (label.tagName === 'LABEL') label.htmlFor = select.id;
      select.addEventListener('change', () => {
        const current = Array.from(field.querySelectorAll('input[type="radio"]'));
        const radio = current[Number(select.value)];
        if (radio && !radio.disabled) radio.click();
        schedule();
      });
      field.append(select);
      containers.forEach(container => container.classList.add('easy-unified-original'));
      radios.forEach(radio => {
        const optionLabel = radio.closest('label') || field.querySelector('label[for="' + CSS.escape(radio.id) + '"]');
        if (optionLabel && optionLabel !== label) optionLabel.style.setProperty('display', 'none', 'important');
      });
      binding = { select, signature: '' };
      bindings.set(field, binding);
    }
    const items = radios.map((radio, index) => ({
      index,
      text: (() => {
        const source = radio.closest('label') || field.querySelector('label[for="' + CSS.escape(radio.id) + '"]');
        const copy = source?.cloneNode(true);
        copy?.querySelectorAll('.visually-hidden,.label-unavailable,input').forEach(node => node.remove());
        return compact(copy?.textContent || radio.value);
      })(),
      disabled: radio.disabled,
      checked: radio.checked
    }));
    const signature = JSON.stringify(items.map(item => [item.text, item.disabled]));
    if (signature !== binding.signature) {
      binding.select.replaceChildren(...items.map(item => {
        const option = document.createElement('option');
        option.value = String(item.index);
        option.textContent = item.text;
        option.disabled = item.disabled;
        return option;
      }));
      binding.signature = signature;
    }
    const selected = items.find(item => item.checked);
    binding.select.value = selected ? String(selected.index) : '';
    const disabled = items.every(item => item.disabled);
    if (binding.select.disabled !== disabled) binding.select.disabled = disabled;
  }
  function refresh() {
    scheduled = false;
    document.querySelectorAll('.easy-area-calculator,variant-selects,variant-radios').forEach(root => {
      root.querySelectorAll('[data-easy-variant-field],.easy-flyer-field,.product-form__input').forEach(field => {
        if (field.closest('.easy-area-calculator__shipping,.easy-banner-jobs') || field.querySelector('textarea,input[type="file"]') || field.hidden) return;
        if (!field.querySelector(labels)) return;
        field.classList.add('easy-unified-field');
        mirrorRadios(field);
      });
      root.querySelectorAll('[data-easy-width],[data-easy-height],[data-easy-quantity]:not([type="hidden"])').forEach(control => {
        if (control.parentElement.hidden || control.closest('.easy-banner-jobs,.easy-banner-aggregate-quantity')) return;
        control.parentElement.classList.add('easy-unified-field');
        if (control.matches('[data-easy-width],[data-easy-height]')) control.parentElement.parentElement.classList.add('easy-unified-stack');
      });
      root.querySelectorAll('.easy-area-calculator__finishing,.easy-booth-module').forEach(container => container.classList.add('easy-unified-options'));
    });
  }
  function schedule() {
    if (!scheduled) { scheduled = true; requestAnimationFrame(refresh); }
  }
  document.addEventListener('change', schedule);
  document.addEventListener('shopify:section:load', schedule);
  new MutationObserver(records => {
    if (records.some(record => record.type === 'childList' || ['disabled','checked','hidden'].includes(record.attributeName))) schedule();
  }).observe(document.getElementById('MainContent') || document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled','checked','hidden'] });
  refresh();
})();
